import { render } from "./AgencyClients.vue?vue&type=template&id=acc035fc"
import script from "./AgencyClients.vue?vue&type=script&lang=js"
export * from "./AgencyClients.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/agencies/AgencyClients.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "acc035fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('acc035fc', __exports__)) {
    api.reload('acc035fc', __exports__)
  }
  
  module.hot.accept("./AgencyClients.vue?vue&type=template&id=acc035fc", () => {
    api.rerender('acc035fc', render)
  })

}


export default __exports__